<template>

  <el-container class="home-container">
    <!-- 侧边栏 -->
    <el-aside style="background-color:#2a0608" :width="isCollapse ? '50px' : '215px'">
      <!-- 头部logo -->
      <template>
        <div class="header-title" v-if="!isCollapse">
          <img width="50px" height="50px" src="../assets/logo.png" style="border-radius: 5px">
          <span style="font-weight:bold">菲范物联平台</span>
        </div>
        <div class="header-title-hiddle" v-else>
          <img width="40px" height="40px" src="../assets/logo.png" style="border-radius: 5px">
        </div>
      </template>
      <el-menu background-color="#2a0608" text-color="#fff" active-text-color="#fff" :collapse="isCollapse"
        :collapse-transition="false" :default-active="'/' + activePath" router >
        <!-- 调用递归组件 -->
        <menu-item :menu-list="menuList" @select-menu="selectMenu" />
      </el-menu>
    </el-aside>

    <!-- 主体 -->
    <el-container>
      <!-- 头部 -->
      <el-header>
        <!-- 头部导航栏 -->
        <div class="header-row">
          <!-- 折叠 展开 和 名人名言 -->
          <div class="toggle-button">
            <div>
              <i :title="isCollapse ? '展开' : '收起'" class="fa fa-bars" @click="toggleCollapse"></i>
            </div>
            <div style="height:20px;width:100%;margin-left:10px">
              <div style="float:left;color:#E74405;font-size:16px;height:20px;line-height:20px;">
                <i class="fa fa-bullhorn"></i>
              </div>
              <el-carousel height="25px" direction="vertical" indicator-position="none" autoplay :interval="8000"></el-carousel>
            </div>
          </div>
          <!-- 头像下拉菜单 -->
          <div class="header-avatar">
            <div class="user">
              {{ this.information }}，您好！
            </div>
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                <img width="35" height="35" style="border-radius:50%;background:#dddddd"
                  src="../assets/images/index/user3.png" alt="">
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="update-password">修改密码</el-dropdown-item>
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div>
            <el-dropdown :hide-on-click="false" style="display:flex;width:80px;" @command="handleLanguage">
              <span class="el-dropdown-link" style="font-size:16px;font-weight:bold;line-height:40px;">
                语言<i class="el-icon-open"></i>
                <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="zh">中文</el-dropdown-item>
                <el-dropdown-item command="en">英文</el-dropdown-item>
                <el-dropdown-item command="viet">越南文</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <!-- tab标签页区域 - 用于标签页切换 -->
        <!-- <div class="tabs-switch-page">
          <el-tag size="medium" v-for="(tab, index) in tabList" :key="tab.name" @close="handleClose(tab, index)"
            @click="changeMenu(tab)" :closable="tab.name !== 'home'"
            :effect="activePath === tab.name ? 'dark' : 'plain'">
            {{ tab.label }}
          </el-tag>
        </div> -->
        <div class="tabs-switch-page" @contextmenu.prevent="showContextMenu($event)">
          <el-tag size="medium" v-for="(tab, index) in tabList" :key="tab.name" @close="handleClose(tab, index)"
            @click="changeMenu(tab)" :closable="tab.name !== 'home'" 
            :effect="activePath === tab.name ? 'dark' : 'plain'">
            {{ tab.label }}
          </el-tag>
        </div>
        <div v-show="showContext" :style="{ left: left + 'px', top: top + 'px' }" class="zdiv">
          <li @click="closeAllTabs" style="color:#f5212d">关闭所有标签</li>
          <li @click="closeOtherTab" style="color:#f5212d">关闭其他标签</li>
        </div>
      </el-header>
      <!-- 内容区 -->
      <el-main>
        <!-- 路由占位符，用于展示内容区的内容 -->
        <div style="padding:1px">
          <keep-alive :include="catch_components">
            <router-view />
          </keep-alive>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import MenuItem from './MenuItem.vue'; // 引入递归组件
import { mapState, mapMutations } from 'vuex';
export default {
  components: {
    MenuItem,
  },
  //组件被创建
  created() {
    //加载菜单
    this.loadMenu();
    this.inFormation();
    // document.addEventListener('click', this.handleDocumentClick);
  },
  beforeDestroy() {
    // document.removeEventListener('click', this.handleDocumentClick);
  },
  mounted() {
    document.addEventListener('click', this.hideMenu);
  },
  computed: {
    ...mapState({ // 从 state 中的到的计算属性
      activePath: state => state.activePath, // 已选中菜单
      tabList: state => state.tabList,  // tags菜单列表
      catch_components: state => state.catch_components,  // keepalive缓存
    }),
  },
  data() {
    return {
      //菜单列表
      menuList: [],
      // 折叠-展开 默认false不折叠 
      isCollapse: false,
      information: '',
      showContext: false,
      left: 0, // 右键菜单的位置
      top: 0, // 右键菜单的位置
      target: "",//邮寄鼠标内容
    }
  },
  methods: {
    handleLanguage(command) {
      switch (command) {
        // 退出
        case 'zh':
          this.$i18n.locale = 'zh';
          break
        case 'en':
          // this.test()
          this.$i18n.locale = 'en';
          break;
        case 'viet':
          this.$i18n.locale = 'viet';
          // this.newReq()
          break;
      }
    },
    hideMenu() {
      this.showContext = false;
    },

    // 新增或修改的方法
    showContextMenu(e) {
      this.showContext = true;
      this.target = e.target.textContent.trim();
      this.left = e.clientX;
      this.top = e.clientY;
    },

    closeAllTabs() {
      var oldTabList = this.$store.state.tabList;
      const newtabList = oldTabList.filter(tab => tab.name == 'home');
      this.showContext = false;
      oldTabList = newtabList;
      this.$store.commit('closeTab', { activePath: 'home', tabList: oldTabList });
      this.$router.push("/home")

    },
    closeOtherTab() {
      var oldTabList = this.$store.state.tabList;
      const targetObject = oldTabList.find(tab => tab.label == this.target);
      const path = targetObject.path;
      const name = targetObject.name;
      const newTabList = oldTabList.filter(tab => (tab.name == 'home' || tab.name == name));
      this.showContext = false;
      oldTabList = newTabList;
      this.$store.commit('closeTab', { activePath: path, tabList: oldTabList });
      this.$router.push(`${path}`)
    },
    changePWD() {
      this.$router.push("/changePWD");
    },

    // 获取登陆人姓名
    inFormation() {
      const value = localStorage.getItem('name');
      this.information = value;

    },
    // 退出登录请求
    async logOut1() {
      await this.$api.logout( ).then(res =>{
          alert('退出登录成功！')
      })
        localStorage.removeItem('token');
        localStorage.clear();
        //跳转到首页
        this.$router.push("/login");
    },
    // 右上角下拉菜单点击事件
    handleCommand(command) {
      switch (command) {
        // 退出
        case 'logout':
          this.logOut1()
          this.$store.commit('clearVUEX')
          break
        case 'update-password':
          this.changePWD()
          break
      }
    },
    // 点击折叠 展开菜单
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    // 点击菜单 - 传入name，添加到keepalive缓存页面
    selectMenu(item) {
        // 加入keepalive缓存
        this.$store.commit('addKeepAliveCache', item.name)
        //添加tags标签
        //访问wellcome 就代表home
        var name = item.name === 'wellcome' ? 'home' : item.name
        var submenu = {
          path: item.path,
          name: name,
          label: item.label
        }
        //修改选中菜单
        this.$store.commit('selectMenu', submenu)
    },
    // 关闭tab标签
    handleClose(tab, index) {
      // 历史选中菜单
      var oldActivePath = this.$store.state.activePath
      // 历史已选中菜单列表
      var oldTabList = this.$store.state.tabList
      // 计算标签个数
      let length = oldTabList.length - 1
      // 删除tabList中的该对象
      for (let i = 0; i < oldTabList.length; i++) {
        let item = oldTabList[i]
        if (item.name === tab.name) {
          oldTabList.splice(i, 1);
        }
      }
      // 删除keepAlive缓存
      this.$store.commit('removeKeepAliveCache', tab.name)
      // 如果关闭的标签不是当前路由的话，就不跳转
      if (tab.name !== oldActivePath) {
        return
      }
      // 如果length为1，必然只剩下首页标签，此时关闭后，更新到首页
      if (length === 1) {
        // 同时存储菜单
        this.$store.commit('closeTab', { activePath: 'home', tabList: oldTabList })
        // tab页向左跳转
        this.$router.push({ path: oldTabList[index - 1].path })
        // this.$router.push({ name: oldTabList[index - 1].name })
        // 不再向下执行
        return
      }
      // 关闭的标签是最右边的话，往左边跳转一个
      if (index === length) {
        // 同时更新路径
        oldActivePath = oldTabList[index - 1].name
        // 同时存储菜单
        this.$store.commit('closeTab', { activePath: oldActivePath, tabList: oldTabList })
        // tab页向左跳转
        this.$router.push({ path: oldTabList[index - 1].path })
        // this.$router.push({ name: oldTabList[index - 1].name })
      } else {
        // 同时更新路径
        oldActivePath = oldTabList[index].name
        // 同时存储菜单
        this.$store.commit('closeTab', { activePath: oldActivePath, tabList: oldTabList })
        // tab页向右跳转
        this.$router.push({ path: oldTabList[index].path })
        // this.$router.push({ name: oldTabList[index].name })
      }
    },

    // 点击标签跳转路由
    changeMenu(item) {
      // 历史选中菜单
      var oldActivePath = this.$store.state.activePath
      // 首先判断点击的是否是自己，如果是自己则return
      if (oldActivePath === item.name) {
        return
      }
      // 不是自己，存储菜单
      this.$store.commit('changeMenu', item.name)
      // 页面跳转
      this.$router.push({ path: item.path })
      // this.$router.push({ name: item.name })
    },
    //加载菜单
    loadMenu() {
      this.$api.getMenusByUser( ).then(res =>{
          this.menuList = res;
          const newObject = {
            id: 'number-01',
            clazz: 'el-icon-setting',
            path: '/home',
            label: '首页',
            name: 'home'
          };
          this.menuList = [newObject].concat(this.menuList);
      })
    }
  },
};
</script>
<style lang="less" scoped>
/* 新增右键菜单的样式部分 */
// ::v-deep {
//   .custom-context-menu {
//     top: v-bind('contextMenuY + "px"');
//     left: v-bind('contextMenuX + "px"');
//     position: absolute;
//     z-index: 9999;
//   }
// }


.zdiv {
  margin: 0;
  border: 1px solid rgb(187, 186, 186);
  background: rgb(255, 255, 255);
  z-index: 1000;
  position: absolute;
  list-style-type: none;
  padding: 5px;
  border-radius: 7px;
  font-size: 12px;
}

.zdiv li {
  margin: 0;
  padding: 5px;
  padding-top: 7px;
  padding-bottom: 7px;
}

.zdiv li:hover {
  background: #e1e1e1;
  cursor: pointer;
}

.el-col-align-middle {
  line-height: 40px;
  text-align: left;
  font-size: 14px;
}

.home-container {
  height: 100%;
}

.el-header {
  color: rgb(0, 0, 0);
  font-size: 20px;
  border-bottom: 1px solid #dddddd;
  height: 82px !important;
  padding: 0;
  background: #fff;
}

.header-row {
  height: 40px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-bottom: 1px solid #dddddd;
  overflow: hidden;
}

.header-avatar {
  float: right;
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;

  .user {
    font-size: 14px;
    font-weight: bold;
    padding: 0 10px;
  }
}

.el-aside {
  // background-color: #282C34;

  .header-title {
    padding-left: 10px;
    height: 60px;
    font-weight: 300;
    display: flex;
    font-size: 18px;
    align-items: center;
    cursor: pointer;
    color: #ffffff;

    span {
      margin-left: 10px;
    }
  }

  .header-title-hiddle {
    width: 64px;
    height: 60px;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    color: #ffffff;
    cursor: pointer;
  }

  .el-menu {
    border-right: none;
  }
}

// 菜单选中背景色
.el-menu-item.is-active {
  background-color: #f5212d !important;
}

// 菜单悬浮背景色
.el-menu-item:hover {
  background-color: #f5212d !important;
}

// 走马灯
.el-carousel__item h3 {
  color: #ee7c12;
  font-size: 14px;
  opacity: 0.75;
  line-height: 25px;
  margin: 0;
}

.el-main {
  background-color: #eaedf1;
  padding: 0;
}

.fa {
  margin-right: 10px;
}

// 点击展开/折叠按钮
.toggle-button {
  width: 80%;
  font-size: 20px;
  line-height: 40px;
  color: #595959;
  text-align: left;
  display: flex;
  align-items: center;
  float: left;
  padding-left: 20px;

  i {
    cursor: pointer;
  }
}

// 面包屑导航
.el-breadcrumb {
  margin-bottom: 0;
}

// tab页
.tabs-switch-page {
  display: flex;
  align-items: center;
  height: 40px;
  background-color: #fff;
  overflow: hidden;
}

.el-tag {
  cursor: pointer;
  margin-left: 10px;
  border-radius: 2px;
  font-size: 12px;
  color: #f5212d;
  border-color: #f5212d;
}

.el-tag--dark {
  color: #fff;
  background-color: #f5212d;
}

.el-dropdown-link {
  cursor: pointer;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.submit-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
</style>